import Vue from 'vue'
import Router from 'vue-router'
import store from './store'

Vue.use(Router)

const ifAuthenticated = async (to, from, next) => {
  document.title = to.meta.name + (to.meta.name.length ? ' - ' : '') + 'Центр работ под напряжением'
  if (!to.meta.requiredAuth) {
    next()
    return
  }
  if (!store.state.auth.auth) {
    next(from.path)
    return
  }
  if (!to.meta.roles.includes(store.state.auth.role[0]) && to.meta.roles.length) {
    next(from.path)
    return
  }
  next()
}

const router = new Router({
  mode: 'history',
  scrollBehavior() {
    return { x: 0, y: 0 }
  },
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => {
        if (!Vue.prototype.$browserDetect.isIE) {
          return import('./pages/Home')
        } else {
          return import('./pages/HomeIE')
        }
      },
      meta: {
        roles: [],
        requiredAuth: false,
        name: ''
      }
    },
    {
      path: '/course-info/:id',
      name: 'course-info_id',
      component: () => import('./pages/course-info'),
      meta: {
        roles: [],
        requiredAuth: false,
        name: 'Информация о курсе'
      }
    },
    {
      path: '/course-preview/:id',
      name: 'course-preview_id',
      component: () => import('./pages/course-preview'),
      meta: {
        roles: ['admin', 'methodist', 'leader'],
        requiredAuth: true,
        name: 'Предварительный просмотр курса'
      }
    },
    {
      path: '/users',
      name: 'users',
      component: () => import('./pages/users'),
      meta: {
        roles: ['leader', 'leader_admin'],
        requiredAuth: true,
        name: 'Пользователи'
      }
    },
    {
      path: '/users/:id',
      name: 'users_id',
      component: () => import('./pages/users/_id.vue'),
      meta: {
        roles: ['leader', 'leader_admin'],
        requiredAuth: true,
        name: 'Профиль пользователя'
      }
    },
    {
      path: '/groups',
      name: 'groups',
      component: () => import('./pages/groups'),
      meta: {
        roles: ['admin', 'leader'],
        requiredAuth: true,
        name: 'Группы'
      }
    },
    {
      path: '/groups/:id',
      name: 'groups_id',
      component: () => import('./pages/groups/_id.vue'),
      meta: {
        roles: ['admin', 'leader'],
        requiredAuth: true,
        name: 'Группа'
      }
    },
    {
      path: '/my-statistic',
      name: 'my-statistic',
      component: () => import('./pages/my-statistic'),
      meta: {
        roles: ['user'],
        requiredAuth: true,
        name: 'Моя статистика'
      }
    },
    {
      path: '/my-courses',
      name: 'my-courses',
      component: () => import('./pages/my-courses'),
      meta: {
        roles: ['user'],
        requiredAuth: true,
        name: 'Курсы'
      }
    },
    {
      path: '/my-courses/:id',
      name: 'my-courses_id',
      component: () => import('./pages/my-courses/_id.vue'),
      meta: {
        roles: ['user'],
        requiredAuth: true,
        name: 'Прохождение курса'
      }
    },
    {
      path: '/profile',
      name: 'profile',
      component: () => import('./pages/profile'),
      meta: {
        roles: ['user', 'admin', 'methodist', 'leader', 'leader_admin'],
        requiredAuth: true,
        name: 'Профиль'
      }
    },
    {
      path: '/my-notifications',
      name: 'my-notifications',
      component: () => import('./pages/my-notifications'),
      meta: {
        roles: ['user', 'admin', 'leader', 'leader_admin'],
        requiredAuth: true,
        name: 'Уведомления'
      }
    },
    {
      path: '/my-requests',
      name: 'my-requests',
      component: () => import('./pages/my-requests'),
      meta: {
        roles: ['admin'],
        requiredAuth: true,
        name: 'Заявки'
      }
    },
    {
      path: '/branches',
      name: 'branches',
      component: () => import('./pages/branches'),
      meta: {
        roles: ['admin'],
        requiredAuth: true,
        name: 'Филиалы'
      }
    },
    {
      path: '/branches/:id',
      name: 'branches_id',
      component: () => import('./pages/branches/_id.vue'),
      meta: {
        roles: ['admin', 'leader'],
        requiredAuth: true,
        name: 'Филиал'
      }
    },
    {
      path: '/all-users',
      name: 'all-users',
      component: () => import('./pages/all-users'),
      meta: {
        roles: ['admin'],
        requiredAuth: true,
        name: 'Пользователи'
      }
    },
    {
      path: '/all-users/:id',
      name: 'all-users_id',
      component: () => import('./pages/all-users/_id.vue'),
      meta: {
        roles: ['admin'],
        requiredAuth: true,
        name: 'Профиль пользователя'
      }
    },
    {
      path: '/all-courses',
      name: 'all-courses',
      component: () => import('./pages/all-courses'),
      meta: {
        roles: ['admin', 'methodist'],
        requiredAuth: true,
        name: 'Курсы'
      }
    },
    {
      path: '/all-courses/create',
      name: 'all-courses_create',
      component: () => import('./pages/all-courses/create'),
      meta: {
        roles: ['admin', 'methodist'],
        requiredAuth: true,
        name: 'Создание курса'
      }
    },
    {
      path: '/all-courses/create/:id',
      name: 'all-courses_create_id',
      component: () => import('./pages/all-courses/create/_id.vue'),
      meta: {
        roles: ['admin', 'methodist'],
        requiredAuth: true,
        name: 'Редактирование курса'
      }
    },
    {
      path: '/all-courses/course-statistic/:id',
      name: 'course-statistic_id',
      component: () => import('./pages/all-courses/course-statistic'),
      meta: {
        roles: ['admin', 'methodist'],
        requiredAuth: true,
        name: 'Статистика курса'
      }
    },
    {
      path: '/all-courses/content/:id',
      name: 'all-courses_create_content',
      component: () => import('./pages/all-courses/content'),
      meta: {
        roles: ['admin', 'methodist'],
        requiredAuth: true,
        name: 'Добавление материала'
      }
    },
    {
      path: '/store',
      name: 'store',
      component: () => import('./pages/store'),
      meta: {
        roles: ['admin', 'methodist', 'user'],
        requiredAuth: true,
        name: 'База знаний'
      }
    },
    {
      path: '/search',
      name: 'search-page',
      component: () => import('./pages/search'),
      meta: {
        roles: [],
        requiredAuth: false,
        name: 'Поиск'
      }
    },
    {
      path: '/404',
      name: '404',
      component: () => import('./pages/404.vue'),
      meta: {
        roles: [],
        requiredAuth: false,
        name: '404'
      }
    },
    {
      path: '*',
      redirect: '/404'
    }
  ]
})
router.beforeEach((to, from, next) => {
  ifAuthenticated(to, from, next)
})

export default router
